import { render } from "./categoriesMenu.vue?vue&type=template&id=62d45ab2"
import script from "./categoriesMenu.vue?vue&type=script&lang=js"
export * from "./categoriesMenu.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__